import React from 'react';
import useDialog from '../hooks/useDialog';

function HeroModal({ hero, onInputChange, onImageSelect, onClose, onSubmit, uploadingImage, onRemoveImage }) {
  const dialogRef = useDialog(onClose);

  return (
    <div className="fixed inset-0 modal-overlay flex items-center justify-center p-4" style={{ zIndex: 50 }} onClick={onClose}>
      <div
        ref={dialogRef}
        role="dialog"
        aria-modal="true"
        aria-labelledby="hero-modal-title"
        tabIndex={-1}
        className="bg-white rounded-xl p-8 max-w-lg w-full overflow-y-auto"
        style={{ maxHeight: '90vh' }}
        onClick={(e) => e.stopPropagation()}
      >
        <h3 id="hero-modal-title" className="text-3xl font-bold text-wine mb-6">Edit Hero Section</h3>
        
        <div className="space-y-4">
          <div>
            <label className="block text-wine font-bold mb-2">Background Images (Slideshow):</label>
            <input 
              type="file" 
              accept="image/*" 
              multiple
              onChange={onImageSelect} 
              className="w-full p-3 border border-gray-300 rounded-lg" 
            />
            <p className="text-sm text-gray-500 mt-1">Upload multiple images for a slideshow (max 10). Leave empty for gradient background.</p>
            
            {/* Preview new images being uploaded */}
            {hero.imagePreviews && hero.imagePreviews.length > 0 && (
              <div className="mt-4">
                <p className="text-sm font-bold text-wine mb-2">New Images to Upload:</p>
                <div className="grid grid-cols-3 gap-2">
                  {hero.imagePreviews.map((preview, index) => (
                    <img 
                      key={index}
                      src={preview} 
                      alt={`Preview ${index + 1}`} 
                      style={{ width: '100%', height: '100px', objectFit: 'cover', borderRadius: '8px' }} 
                    />
                  ))}
                </div>
              </div>
            )}

            {/* Show current images */}
            {hero.backgroundImages && hero.backgroundImages.length > 0 && (
              <div className="mt-4">
                <p className="text-sm font-bold text-wine mb-2">Current Images ({hero.backgroundImages.length}):</p>
                <div className="grid grid-cols-3 gap-2">
                  {hero.backgroundImages.map((image, index) => (
                    <div key={index} className="relative">
                      <img 
                        src={image} 
                        alt={`Image ${index + 1}`} 
                        style={{ width: '100%', height: '100px', objectFit: 'cover', borderRadius: '8px' }} 
                      />
                      <button
                        type="button"
                        onClick={() => onRemoveImage(index)}
                        aria-label={`Remove background image ${index + 1}`}
                        className="absolute top-1 right-1 bg-red-600 text-white w-6 h-6 rounded-full text-xs hover:bg-red-700"
                      >
                        <span aria-hidden="true">✕</span>
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>

          <div>
            <label className="block text-wine font-bold mb-2">Main Title:</label>
            <input 
              type="text" 
              value={hero.title || ''} 
              onChange={(e) => onInputChange('title', e.target.value)} 
              placeholder="Welcome to Vivat Alfa Winery" 
              className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2" 
              style={{ borderColor: '#722f37' }} 
            />
          </div>

          <div>
            <label className="block text-wine font-bold mb-2">Subtitle:</label>
            <input 
              type="text" 
              value={hero.subtitle || ''} 
              onChange={(e) => onInputChange('subtitle', e.target.value)} 
              placeholder="European Style Estate Bottled Wines - Since 2013" 
              className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2" 
              style={{ borderColor: '#722f37' }} 
            />
          </div>

          <div>
            <label className="block text-wine font-bold mb-2">Button Text:</label>
            <input 
              type="text" 
              value={hero.buttonText || ''} 
              onChange={(e) => onInputChange('buttonText', e.target.value)} 
              placeholder="Explore Our Collection" 
              className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2" 
              style={{ borderColor: '#722f37' }} 
            />
          </div>
        </div>

        <div className="flex justify-end space-x-3 mt-8">
          <button 
            type="button" 
            onClick={onClose} 
            className="px-6 py-3 bg-gray-300 hover:bg-gray-400 text-gray-800 rounded-lg transition" 
            disabled={uploadingImage}
          >
            Cancel
          </button>
          <button 
            type="button" 
            onClick={onSubmit} 
            className="px-6 py-3 bg-wine hover:bg-wine-light text-white rounded-lg transition" 
            style={{ backgroundColor: '#722f37' }} 
            disabled={uploadingImage}
          >
            {uploadingImage ? 'Uploading...' : 'Save Changes'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default HeroModal;
